import { useEffect } from 'react';
import { useApplicationContext } from '../ApplicationContext';
import {
  hideContactBrandFloatButton,
  resetContactBrandFloatButtonState,
} from '../reducer/applicationContextReducer.actions';

const useHideContactBrandButton = () => {
  const { dispatch } = useApplicationContext();

  useEffect(() => {
    dispatch(hideContactBrandFloatButton());

    return () => {
      dispatch(resetContactBrandFloatButtonState());
    };
  }, []);
};

export default useHideContactBrandButton;
